import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * ShortLinkRedirect - Resolves a short link code and redirects to the full prep page
 * Route: /p/:code
 */
const ShortLinkRedirect = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    resolveShortLink();
  }, [code]);

  const resolveShortLink = async () => {
    try {
      const response = await axios.get(`${API}/api/p/${code}`);
      const { appointment_id, token } = response.data;
      
      // Redirect to the full prep page with token
      navigate(`/prep/${appointment_id}?t=${token}`, { replace: true });
    } catch (err) {
      console.error('Failed to resolve short link:', err);
      if (err.response?.status === 410) {
        setError('Dette link er udløbet. Kontakt venligst din administrator.');
      } else if (err.response?.status === 404) {
        setError('Link ikke fundet. Tjek venligst at linket er korrekt.');
      } else {
        setError('Der opstod en fejl. Prøv venligst igen.');
      }
    }
  };

  if (error) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h1 className="text-xl font-bold text-slate-900 mb-2">Link fejl</h1>
          <p className="text-slate-600">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-slate-400 mx-auto mb-4" />
        <p className="text-slate-500">Indlæser...</p>
      </div>
    </div>
  );
};

export default ShortLinkRedirect;
